export slide from './slide'



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/